import React from 'react';
import Button from 'yoda-core-components/lib/components/Button';
import { useSelector } from 'react-redux';
import { getURLParameterBykey } from '../../utils';
import * as styles from './NoBrandResults.css';

const brandConfig = {
    brandParamName: 'brand',
};

const brandName = getURLParameterBykey(brandConfig.brandParamName);

const config = {
    headerMessage: "Its Not You, it's Us",
    refreshButtonName: 'Refresh The Page',
    message: `Something went wrong loading products for ${brandName}. We hope you’ll give us another chance.`,
};

const refresh = () => {
    if (window && window.location) {
        return window.location.reload();
    }
    return null;
};
const NoBrandPageResults = () => {
    const { deviceType: { isMobile = false } = {} } = useSelector(({ context = {} }) => context);
    return (
        <div
            className={
                isMobile
                    ? `mt-3 text-center mx-auto ${styles.mobileContainer}`
                    : `mt-3 text-center mx-auto ${styles.container}`
            }
        >
            <div className="font-open-sans-bold mb-2 mt-2 text-gray-600 text-xlarge">
                {config.headerMessage}
            </div>
            <div className="text-gray-500 text-small">{config.message}</div>
            <div className={`mb-4 mt-4 mx-auto ${styles.refreshButtonContainer}`}>
                <Button automationId="no results refresh button" onClick={refresh}>
                    {config.refreshButtonName}
                </Button>
            </div>
        </div>
    );
};

export default NoBrandPageResults;
